import { NgClass, NgFor } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ColorBarComponent } from '../color-bar/color-bar.component';

@Component({
  selector: 'app-mitre-color-bars',
  templateUrl: './color-bars.component.html',
  styleUrls: ['./color-bars.component.css'],
  imports: [
    NgClass,
    NgFor,
    ColorBarComponent
  ],
  standalone: true
})
export class ColorBarsComponent {
  @Input() colors: string[] = [];

  @Input() height = '50px';

  @Input() rounded = false;
}
